module.exports = __webpack_public_path__ + "img/task.9e0bf787.svg";